/**
 * Removes accents from string replacing them with regular characters
 * @param value string to remove accents from
 * @returns string without accents
 */
export function removeAccents(value: string): string {
	return value.normalize("NFD").replace(/\p{Diacritic}/gu, "");
}
